import { ColorLuminance } from "../../helpers";

const defaultTheme = {
  headingColor: "#004f3c",
  backgroundColor: "#ffffff",
  textColor: "#000000"
};

export const chevronString = (color: string) =>
  `url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg id='Layer_1' data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cdefs%3E%3Cstyle%3E .cls-1, .cls-2 %7B fill: none; %7D .cls-2 %7B stroke: %23${color.replace(
    "#",
    ""
  )}; stroke-width: 2px; %7D %3C/style%3E%3C/defs%3E%3Cg%3E%3Cg%3E%3Cg%3E%3Cg%3E%3Cg%3E%3Crect id='Rectangle' class='cls-1' width='24' height='24'/%3E%3Cpolyline id='Path-5' class='cls-2' points='18 9 12 15 6 9'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`;

export const loadTheming = ({
  backgroundColor,
  headingColor,
  textColor
}: {
  backgroundColor: string;
  headingColor: string;
  textColor: string;
}) => {
  const txtColor = textColor || defaultTheme.textColor;
  const bgColor = backgroundColor || defaultTheme.backgroundColor;
  const progressBarValue = txtColor;
  const progressBarValueFill = ColorLuminance(
    bgColor == "#000000" ? txtColor : bgColor,
    bgColor == "#000000" ? -0.7 : -0.3
  );
  const theming: Record<string, unknown> = {
    "--timeline-backgroundColor":
      backgroundColor || defaultTheme.backgroundColor,
    "--timeline-headingColor": headingColor || defaultTheme.headingColor,
    "--timeline-textColor": textColor || defaultTheme.textColor,
    "--timeline-progressBar": progressBarValue,
    "--timeline-progressBar-Bg": progressBarValueFill,
    "--timeline-chevron": chevronString(
      headingColor || defaultTheme.headingColor
    )
  };
  const themingCSS = `:root {${Object.keys(theming).reduce(
    (cssString: string, key: string) => {
      return theming[key] != ""
        ? cssString + `${key}: ${theming[key]};`
        : cssString;
    },
    ""
  )}}`;

  if (Object.keys(theming).some(key => theming[key])) {
    const heading = document.querySelector("head");
    const timelineTheming = document.querySelector("#timeline-theming");
    const style = document.createElement("style");
    style.id = "timeline-theming";
    style.innerHTML = themingCSS;
    if (!timelineTheming && heading) {
      heading.appendChild(style);
    }
  }
};
